<template>
	<div class="stacks">
		<ul class="stack-list" ref="stacks">
			
			<create-stack-form :user="user" v-if="user"></create-stack-form> 
			<li class="card stack" @click="$router.push({ name: 'cards'})"><router-link :to="{ name: 'cards'}"><h2 class="stack-title">My cards</h2></router-link></li>
			<stack v-for="stack in stacks" :stack="stack" :user="user" :key="stack.key"></stack>
			
		</ul>
		<update-stack-modal></update-stack-modal>
	</div>

  

    
  
</template>

<script>
	import Auth from '../../data/Auth'
	import stackFunctions from '../../data/stackFunctions'
	import EventBus from '../EventBus'
	import CreateStackForm from '../cards/CreateStack'
	import Stack from '../cards/Stack'
	import UpdateStackModal from '../cards/UpdateStackModal'

	export default {
		data() {
			return {
				stacks:[],
				loadStacks: true,

			}
		},
		props: ['user', 'loading'],
		components: {
			CreateStackForm,
			Stack,
			UpdateStackModal

		},
		computed: {
		},
		methods: {
		},
		created() {
			//console.log(this.user)
		},
		mounted () {
			stackFunctions.on('added', (stack) => {
	      		this.stacks.unshift(stack) // add the card to the beginning of the array
	      		if(this.loadStacks) {
	      			EventBus.$emit('loaded')
	      			this.loadStacks = false;
	      		}
	      	})

	      	stackFunctions.on('changed', ({key, title, description, slug, cards}) => {
	      	    let outdatedStack = stackFunctions.find(this.stacks, key) // get specific note from the notes in our VM by key
	      	    outdatedStack.title = title
	      	    outdatedStack.description = description
	      	    outdatedStack.slug = slug
	      	    outdatedStack.cards = cards
	      	})

	      	stackFunctions.on('removed', ({key}) => {
	      	    let stackToRemove = stackFunctions.findIndex(this.stacks, key) // get specific note from the notes in our VM by key
	      	    this.stacks.splice(stackToRemove, 1) // remove note from notes array
	      	})

	      	stackFunctions.attachFirebaseListeners()


	    },
	    beforeDestroy() {
	      stackFunctions.detachFirebaseListeners()
	    }
	}
</script>


// WEBPACK FOOTER //
// Stacks.vue?d12542da